import React, { useEffect } from "react";

function DesktopComputerForm({ additionalAttributes, setAdditionalAttributes, subCategoryId }) {

  // Debug logging
  useEffect(() => {
    console.log('🖥️ DesktopComputerForm mounted with subCategoryId:', subCategoryId);
    console.log('📋 Current additionalAttributes:', additionalAttributes);
  }, [subCategoryId, additionalAttributes]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`🔧 Field changed: ${name} = ${value}`);
    
    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: value
    });
  };

  const handleBooleanChange = (e) => {
    const { name, value } = e.target;
    const boolValue = value === "true";
    
    console.log(`✅ Boolean field changed: ${name} = ${boolValue}`);
    
    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: boolValue
    });
  };

  return (
    <div className="desktopComputerForm">
      <div>
        <h3>
          Prosessor <span>*</span>
          <span className="tooltip-icon" title="Məsələn: Intel Core i7, AMD Ryzen 5">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="processor" 
          onChange={handleChange}
          placeholder="Intel Core i7-12700K" 
          required
        />
      </div>

      <div>
        <h3>
          RAM (GB) <span>*</span>
          <span className="tooltip-icon" title="Operativ yaddaş həcmi">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="ram" 
          onChange={handleChange}
          placeholder="16"
          min="1"
          max="256"
          required
        />
      </div>
      
      <div>
        <h3>
          Disk növü <span>*</span>
          <span className="tooltip-icon" title="SSD daha sürətlidir">ℹ️</span>
        </h3>
        <select name="storageType" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="HDD">HDD (Hard Disk Drive)</option>
          <option value="SSD">SSD (Solid State Drive)</option>
          <option value="NVMe">NVMe SSD (Ən sürətli)</option>
        </select>
      </div>

      <div>
        <h3>
          Disk həcmi (GB) <span>*</span>
          <span className="tooltip-icon" title="Ümumi yaddaş həcmi">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="storageCapacity" 
          onChange={handleChange}
          placeholder="512"
          min="64"
          step="64"
          required
        />
      </div>

      <div>
        <h3>
          Ekran ölçüsü (inch) <span>*</span>
          <span className="tooltip-icon" title="Monitor ölçüsü">ℹ️</span>
        </h3>
        <input 
          type="number" 
          step="0.1" 
          name="screenSize" 
          onChange={handleChange}
          placeholder="27.0"
          min="15"
          max="50"
          required
        />
      </div>

      <div>
        <h3>
          Yenilənmə tezliyi (Hz) <span>*</span>
          <span className="tooltip-icon" title="Daha yüksək daha yaxşıdır (oyun üçün)">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="refreshRate" 
          onChange={handleChange}
          placeholder="144"
          min="60"
          max="360"
          required
        />
      </div>

      <div>
        <h3>
          Ekran kartı (GPU) <span>*</span>
          <span className="tooltip-icon" title="Məsələn: NVIDIA RTX 4070, AMD RX 7800">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="gpu" 
          onChange={handleChange}
          placeholder="NVIDIA GeForce RTX 4070"
          required
        />
      </div>

      <div>
        <h3>
          Əməliyyat sistemi <span>*</span>
          <span className="tooltip-icon" title="Quraşdırılmış OS">ℹ️</span>
        </h3>
        <select name="operatingSystem" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Windows">Windows 11 / 10</option>
          <option value="Linux">Linux (Ubuntu, Fedora və s.)</option>
          <option value="macOS">macOS</option>
          <option value="Yoxdur">OS yoxdur</option>
        </select>
      </div>

      <div>
        <h3>
          WiFi dəstəyi <span>*</span>
          <span className="tooltip-icon" title="Simsiz internet">ℹ️</span>
        </h3>
        <select name="hasWiFi" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli</option>
          <option value="false">Xeyr</option>
        </select>
      </div>

      <div>
        <h3>
          Bluetooth <span>*</span>
          <span className="tooltip-icon" title="Simsiz əlaqə">ℹ️</span>
        </h3>
        <select name="hasBluetooth" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli</option>
          <option value="false">Xeyr</option>
        </select>
      </div>

      <div>
        <h3>
          Zəmanət <span>*</span>
          <span className="tooltip-icon" title="Rəsmi zəmanət varmı?">ℹ️</span>
        </h3>
        <select name="hasWarranty" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli, var</option>
          <option value="false">Xeyr, yoxdur</option>
        </select>
      </div>

      <div>
        <h3>
          Vəziyyəti <span>*</span>
          <span className="tooltip-icon" title="Məhsulun vəziyyəti">ℹ️</span>
        </h3>
        <select name="condition" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Yeni">Yeni (0 km)</option>
          <option value="İşlənmiş">İşlənmiş (az istifadə)</option>
          <option value="Təmirli">Təmirə ehtiyacı var</option>
        </select>
      </div>
    </div>
  );
}

export default DesktopComputerForm;